var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "radialMenu",
      style: { width: _vm.size + "px", height: _vm.size + "px" },
    },
    [
      _vm.loading
        ? _c("div", { staticClass: "loading-overlay" }, [
            _c("div", { staticClass: "loading-spinner" }),
            _vm._v(" "),
            _c("div", { staticClass: "loading-text" }, [
              _vm._v("AI işlemi yapılıyor..."),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("svg", { staticClass: "icons" }, [
        _c("symbol", { attrs: { id: "fix-grammar", viewBox: "0 0 16 16" } }, [
          _c("path", {
            attrs: {
              d: "M6.57812 14.1621C6.23633 14.1621 5.9834 14.0186 5.74414 13.7246L2.20312 9.29492C2.03223 9.08301 1.95703 8.88477 1.95703 8.67969C1.95703 8.20801 2.30566 7.86621 2.78418 7.86621C3.08496 7.86621 3.29004 7.97559 3.48828 8.24219L6.55078 12.1729L12.4912 2.73926C12.6963 2.41797 12.8945 2.30176 13.2295 2.30176C13.708 2.30176 14.0361 2.62988 14.0361 3.10156C14.0361 3.28613 13.9814 3.47754 13.8379 3.69629L7.41211 13.7178C7.21387 14.0117 6.94043 14.1621 6.57812 14.1621Z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "long-sentence", viewBox: "0 0 16 16" } }, [
          _c("path", {
            attrs: {
              d: "M1.56738 3.25879C1.22559 3.25879 0.952148 2.97852 0.952148 2.63672C0.952148 2.29492 1.21875 2.02148 1.56738 2.02148H14.4258C14.7744 2.02148 15.0479 2.29492 15.0479 2.63672C15.0479 2.97852 14.7676 3.25879 14.4258 3.25879H1.56738ZM1.56738 6.84082C1.22559 6.84082 0.952148 6.56055 0.952148 6.21875C0.952148 5.87695 1.21875 5.60352 1.56738 5.60352H14.4258C14.7744 5.60352 15.0479 5.87695 15.0479 6.21875C15.0479 6.56055 14.7676 6.84082 14.4258 6.84082H1.56738ZM1.56738 10.4229C1.22559 10.4229 0.952148 10.1426 0.952148 9.80078C0.952148 9.45898 1.21875 9.18555 1.56738 9.18555H14.4258C14.7744 9.18555 15.0479 9.45898 15.0479 9.80078C15.0479 10.1426 14.7676 10.4229 14.4258 10.4229H1.56738ZM1.56738 14.0049C1.22559 14.0049 0.952148 13.7246 0.952148 13.3828C0.952148 13.041 1.21875 12.7676 1.56738 12.7676H8.75879C9.10742 12.7676 9.38086 13.041 9.38086 13.3828C9.38086 13.7246 9.10059 14.0049 8.75879 14.0049H1.56738Z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "change-tone", viewBox: "0 0 16 16" } }, [
          _c("path", {
            attrs: {
              d: "M10.0645 1.7207C11.2676 0.510742 12.8467 0.449219 14.043 1.63867C15.2461 2.82812 15.1709 4.4209 13.9541 5.61719L10.0645 1.7207ZM8.17773 14.8594C7.78809 14.8594 7.4873 14.5654 7.4873 14.1758V10.4707L4.07617 13.6357C3.78223 13.9023 3.39258 13.9365 3.04395 13.6016L1.89551 14.5107C1.73828 14.627 1.54688 14.6201 1.41016 14.4766L1.21191 14.2783C1.06836 14.1348 1.06152 13.9365 1.1709 13.7998L2.07324 12.6445C1.74512 12.2891 1.77246 11.8994 2.0459 11.6055L8.38965 4.7832C8.30078 3.9834 8.61523 3.16992 9.32617 2.45898L13.2158 6.35547C12.5117 7.06641 11.6846 7.40137 10.8916 7.3125L8.875 9.17871L8.86816 14.1758C8.86816 14.5654 8.56055 14.8594 8.17773 14.8594ZM2.87988 12.1934L3.49512 12.8086L9.72949 6.875C9.55859 6.76562 9.38086 6.62207 9.22363 6.45801C9.05957 6.28711 8.92969 6.11621 8.81348 5.9248L2.87988 12.1934Z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "translate", viewBox: "0 0 16 16" } }, [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M0.990263 11.9374C1.50923 11.9374 1.80048 11.6727 1.98582 11.0266L2.2453 10.2111H4.86129L5.12077 11.0584C5.29023 11.6833 5.58149 11.9374 6.14281 11.9374C6.70943 11.9374 7.11719 11.5509 7.11719 11.0054C7.11719 10.8042 7.08012 10.6241 6.9901 10.3753L5.089 5.19623C4.79775 4.4019 4.33174 4.06299 3.53212 4.06299C2.77486 4.06299 2.30355 4.41779 2.02289 5.19623L0.137684 10.3753C0.0529553 10.6083 0 10.8466 0 11.0107C0 11.5879 0.375982 11.9374 0.990263 11.9374ZM2.63188 8.74423L3.50034 5.79992H3.54271L4.43765 8.74423H2.63188Z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M9.92506 8.57591C9.38887 8.91351 9.12077 9.32393 9.12077 9.80717C9.12077 10.0653 9.18035 10.2672 9.29951 10.4129C9.42528 10.5519 9.59739 10.6214 9.81584 10.6214C9.82908 10.6214 9.84563 10.6214 9.86549 10.6214C9.88535 10.6148 9.89859 10.6115 9.9052 10.6115C9.96478 10.6115 9.99457 10.5817 9.99457 10.5221V8.6057C9.99457 8.55274 9.9714 8.54281 9.92506 8.57591ZM12.3776 7.97021C12.0864 7.97021 11.805 7.99007 11.5336 8.02979C11.4807 8.04303 11.4542 8.07282 11.4542 8.11915V9.68801C11.4542 9.70125 11.4608 9.71118 11.4741 9.7178C11.4939 9.72442 11.5072 9.72111 11.5138 9.70787C11.9441 9.25773 12.3081 8.70499 12.606 8.04965C12.6126 8.02979 12.6093 8.01324 12.5961 8C12.5829 7.98014 12.5663 7.97021 12.5464 7.97021H12.3776ZM9.64704 11.9718C9.03141 11.9718 8.53493 11.7931 8.15761 11.4356C7.78691 11.0781 7.60156 10.5916 7.60156 9.97597C7.60156 9.30738 7.80346 8.71492 8.20726 8.19859C8.61106 7.67564 9.18366 7.27846 9.92506 7.00705C9.9714 6.98719 9.99457 6.95078 9.99457 6.89783V6.03396C9.99457 5.981 9.96809 5.95452 9.91513 5.95452H8.6243C8.47205 5.95452 8.33966 5.89826 8.22712 5.78572C8.11459 5.67319 8.05832 5.54079 8.05832 5.38854V5.2396C8.05832 5.08735 8.11459 4.95496 8.22712 4.84242C8.33966 4.72989 8.47205 4.67362 8.6243 4.67362H9.91513C9.96809 4.67362 9.99457 4.64714 9.99457 4.59418V4.17715C9.99457 4.02489 10.0508 3.89581 10.1634 3.7899C10.2759 3.67736 10.4083 3.62109 10.5606 3.62109H10.8882C11.0405 3.62109 11.1729 3.67736 11.2854 3.7899C11.3979 3.89581 11.4542 4.02489 11.4542 4.17715V4.59418C11.4542 4.64714 11.484 4.67362 11.5436 4.67362H14.9792C15.1314 4.67362 15.2638 4.72989 15.3764 4.84242C15.4889 4.95496 15.5452 5.08735 15.5452 5.2396V5.38854C15.5452 5.54079 15.4889 5.67319 15.3764 5.78572C15.2638 5.89826 15.1314 5.95452 14.9792 5.95452H11.5436C11.484 5.95452 11.4542 5.981 11.4542 6.03396V6.58008C11.4542 6.62642 11.4807 6.64959 11.5336 6.64959C11.7719 6.62311 12.0533 6.60987 12.3776 6.60987C13.5427 6.60987 14.4364 6.86473 15.0586 7.37444C15.6875 7.87754 16.0019 8.56598 16.0019 9.43978C16.0019 10.1216 15.7934 10.7174 15.3764 11.2271C14.9659 11.7302 14.3966 12.0976 13.6685 12.3293C13.5228 12.3756 13.3805 12.359 13.2415 12.2796C13.1025 12.2002 13.0098 12.0843 12.9635 11.9321L12.8741 11.6541C12.8278 11.515 12.841 11.3793 12.9138 11.2469C12.9867 11.1079 13.0959 11.0086 13.2415 10.9491C13.6188 10.7902 13.92 10.575 14.1451 10.3036C14.3702 10.0322 14.4827 9.74428 14.4827 9.43978C14.4827 9.00288 14.3437 8.66197 14.0657 8.41704C14.0326 8.38394 14.0028 8.39718 13.9763 8.45676C13.5063 9.57548 12.8807 10.4427 12.0996 11.0583C11.3251 11.6673 10.5076 11.9718 9.64704 11.9718Z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "ai-response", viewBox: "0 0 16 16" } }, [
          _c("path", {
            attrs: {
              d: "M8.68359 1.22168V3.32031C8.68359 3.68945 8.36914 4.00391 7.99316 4.00391C7.62402 4.00391 7.30957 3.68945 7.30957 3.32031V1.22168C7.30957 0.845703 7.62402 0.53125 7.99316 0.53125C8.36914 0.53125 8.68359 0.845703 8.68359 1.22168ZM10.8506 4.22266L12.3203 2.75293C12.5801 2.48633 13.0244 2.48633 13.2842 2.74609C13.5508 3.0127 13.5508 3.45703 13.291 3.7168L11.8213 5.18652C11.5615 5.45312 11.1104 5.45312 10.8506 5.19336C10.5908 4.92676 10.584 4.48242 10.8506 4.22266ZM4.16504 5.18652L2.70898 3.70996C2.44922 3.4502 2.44922 3.00586 2.70898 2.74609C2.96875 2.48633 3.41309 2.49316 3.67969 2.75293L5.13574 4.22266C5.39551 4.48242 5.39551 4.92676 5.12891 5.19336C4.86914 5.45312 4.4248 5.44629 4.16504 5.18652ZM13.4414 14.7705L6.94727 8.24219C6.62598 7.91406 6.61914 7.37402 6.94727 7.02539C7.26855 6.69043 7.83594 6.69043 8.16406 7.02539L14.6582 13.5537C14.9863 13.8887 14.9863 14.4287 14.6582 14.7705C14.3438 15.1055 13.7764 15.1055 13.4414 14.7705ZM1.1709 7.35352H3.27637C3.65234 7.35352 3.9668 7.66797 3.9668 8.03711C3.9668 8.40625 3.65234 8.7207 3.27637 8.7207H1.1709C0.801758 8.7207 0.487305 8.40625 0.487305 8.03711C0.487305 7.66797 0.801758 7.35352 1.1709 7.35352ZM14.8154 8.7207H12.7168C12.3477 8.7207 12.0332 8.40625 12.0332 8.03711C12.0332 7.66797 12.3477 7.35352 12.7168 7.35352H14.8154C15.1914 7.35352 15.5059 7.66797 15.5059 8.03711C15.5059 8.40625 15.1914 8.7207 14.8154 8.7207ZM9.5791 10.04L9.96191 9.65723L7.91113 7.60645C7.76758 7.46289 7.59668 7.42871 7.47363 7.54492C7.33691 7.68164 7.38477 7.8457 7.52148 7.98242L9.5791 10.04ZM2.70215 12.3506L4.17188 10.8945C4.43164 10.6348 4.87598 10.6348 5.13574 10.8945C5.39551 11.1611 5.39551 11.5986 5.12891 11.8652L3.66602 13.3281C3.39941 13.5879 2.95508 13.5811 2.68848 13.3145C2.43555 13.0547 2.43555 12.6104 2.70215 12.3506ZM8.68359 12.7607V14.8594C8.68359 15.2354 8.36914 15.5498 7.99316 15.5498C7.62402 15.5498 7.30957 15.2354 7.30957 14.8594V12.7607C7.30957 12.3916 7.62402 12.0771 7.99316 12.0771C8.36914 12.0771 8.68359 12.3916 8.68359 12.7607Z",
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "symbol",
          { attrs: { id: "return", viewBox: "0 0 489.394 489.394" } },
          [
            _c("path", {
              attrs: {
                d: "M375.789,92.867H166.864l17.507-42.795c3.724-9.132,1-19.574-6.691-25.744c-7.701-6.166-18.538-6.508-26.639-0.879L9.574,121.71c-6.197,4.304-9.795,11.457-9.563,18.995c0.231,7.533,4.261,14.446,10.71,18.359l147.925,89.823c8.417,5.108,19.18,4.093,26.481-2.499c7.312-6.591,9.427-17.312,5.219-26.202l-19.443-41.132h204.886c15.119,0,27.418,12.536,27.418,27.654v149.852c0,15.118-12.299,27.19-27.418,27.19h-226.74c-20.226,0-36.623,16.396-36.623,36.622v12.942c0,20.228,16.397,36.624,36.623,36.624h226.74c62.642,0,113.604-50.732,113.604-113.379V206.709C489.395,144.062,438.431,92.867,375.789,92.867z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "close", viewBox: "0 0 41.756 41.756" } }, [
          _c("path", {
            attrs: {
              d: "M27.948,20.878L40.291,8.536c1.953-1.953,1.953-5.119,0-7.071c-1.951-1.952-5.119-1.952-7.07,0L20.878,13.809L8.535,1.465c-1.951-1.952-5.119-1.952-7.07,0c-1.953,1.953-1.953,5.119,0,7.071l12.342,12.342L1.465,33.22c-1.953,1.953-1.953,5.119,0,7.071C2.44,41.268,3.721,41.755,5,41.755c1.278,0,2.56-0.487,3.535-1.464l12.343-12.342l12.343,12.343c0.976,0.977,2.256,1.464,3.535,1.464s2.56-0.487,3.535-1.464c1.953-1.953,1.953-5.119,0-7.071L27.948,20.878z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "run", viewBox: "0 0 512 512" } }, [
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M121,68.5H45c-8.291,0-15,6.709-15,15s6.709,15,15,15h76c8.291,0,15-6.709,15-15S129.291,68.5,121,68.5z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M121,188.5H45c-8.291,0-15,6.709-15,15s6.709,15,15,15h76c8.291,0,15-6.709,15-15S129.291,188.5,121,188.5z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M91,128.5H15c-8.291,0-15,6.709-15,15s6.709,15,15,15h76c8.291,0,15-6.709,15-15S99.291,128.5,91,128.5z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M482,203.5h-91v-60c0-26.346-32.229-40.218-51.22-21.202L219.789,242.289c-11.719,11.719-11.719,30.703,0,42.422\n                l68.789,68.789l-83.789,83.789c-11.719,11.719-11.719,30.703,0,42.422c11.718,11.718,30.703,11.719,42.422,0l105-105\n                c11.719-11.719,11.719-30.703,0-42.422L283.422,263.5L331,215.922V233.5c0,16.567,13.433,30,30,30h121c16.567,0,30-13.433,30-30\n                S498.567,203.5,482,203.5z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M280.14,51.04c-11.924-7.925-27.744-6.357-37.852,3.75l-82.5,82.5c-11.719,11.719-11.719,30.703,0,42.422\n                s30.704,11.718,42.423-0.001l65.112-65.112l21.934,15.8l29.306-29.306c4.902-4.902,10.684-8.707,17.007-11.678L280.14,51.04z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M198.578,305.922c-7.601-7.601-12.675-16.956-15.35-27.072L24.789,437.289c-11.719,11.719-11.719,30.703,0,42.422\n                c11.718,11.718,30.703,11.719,42.422,0l152.578-152.578L198.578,305.922z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("circle", { attrs: { cx: "406", cy: "68.5", r: "45" } }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "walk", viewBox: "0 0 93.646 93.646" } }, [
          _c("path", {
            attrs: {
              d: "M67.971,49.778l-9.378-10.345c-0.584-0.644-1.121-1.971-1.148-2.841L57.1,25.858v-0.311c0-1.654-1.346-3-3-3h-9.18h-3.648\n            c-1.478,0-3.127,1.047-3.756,2.384l-12.358,26.25c-0.342,0.728-0.376,1.541-0.096,2.292c0.28,0.75,0.84,1.342,1.575,1.666\n            l1.821,0.803c0.388,0.171,0.802,0.258,1.231,0.258h0c1.177,0,2.273-0.669,2.794-1.704l5.789-11.517v11.576\n            c-0.024,0.067-0.059,0.128-0.081,0.196l-9.783,30.638c-0.407,1.276-0.283,2.619,0.35,3.781s1.693,1.994,2.987,2.343l0.654,0.177\n            c0.428,0.116,0.872,0.175,1.318,0.175c2.251,0,4.296-1.481,4.974-3.603l9.141-28.628l3.242,7.941\n            c0.791,1.937,1.645,5.329,1.865,7.409l1.551,14.621c0.249,2.341,2.1,4.04,4.402,4.04c0.377,0,0.76-0.046,1.137-0.137l0.659-0.16\n            c2.624-0.635,4.478-3.331,4.133-6.008l-2.297-17.828c-0.292-2.265-1.269-5.812-2.178-7.907l-3.102-7.144\n            c-0.04-0.093-0.097-0.177-0.143-0.267v-4.841l5.59,5.836c0.556,0.581,1.3,0.901,2.094,0.901c0.803,0,1.553-0.326,2.111-0.918\n            l1.034-1.098C69.036,52.899,69.055,50.973,67.971,49.778z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M48.52,20.005c5.516,0,10.003-4.487,10.003-10.003C58.523,4.487,54.036,0,48.52,0c-5.515,0-10.001,4.487-10.001,10.002\n            C38.518,15.518,43.005,20.005,48.52,20.005z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "weapon", viewBox: "0 0 129 129" } }, [
          _c("g", [
            _c("path", {
              attrs: {
                d: "m10.7,68.6h9c1.9,21.6 19.2,38.8 40.7,40.7v9c0,2.2 1.8,4.1 4.1,4.1 2.2,0 4.1-1.8 4.1-4.1v-9c21.6-1.9 38.8-19.2 40.7-40.7h9c2.2,0 4.1-1.8 4.1-4.1 0-2.2-1.8-4.1-4.1-4.1h-9c-1.9-21.6-19.2-38.8-40.7-40.7v-9c0-2.2-1.8-4.1-4.1-4.1-2.2,0-4.1,1.8-4.1,4.1v9c-21.6,1.9-38.8,19.2-40.7,40.7h-9c-2.3,0-4.1,1.8-4.1,4.1 3.55271e-15,2.3 1.9,4.1 4.1,4.1zm33.7-8.2h-16.5c1.9-17.1 15.5-30.7 32.5-32.5v16.5c0,2.2 1.8,4.1 4.1,4.1 2.2,0 4.1-1.8 4.1-4.1v-16.5c17.1,1.9 30.7,15.5 32.5,32.5h-16.5c-2.2,0-4.1,1.8-4.1,4.1 0,2.2 1.8,4.1 4.1,4.1h16.5c-1.9,17.1-15.5,30.7-32.5,32.5v-16.5c0-2.2-1.8-4.1-4.1-4.1-2.2,0-4.1,1.8-4.1,4.1v16.5c-17.1-1.9-30.7-15.5-32.5-32.5h16.5c2.2,0 4.1-1.8 4.1-4.1 0-2.2-1.9-4.1-4.1-4.1z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "more", viewBox: "0 0 408 408" } }, [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M51,153c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S79.05,153,51,153z M357,153c-28.05,0-51,22.95-51,51\n                s22.95,51,51,51s51-22.95,51-51S385.05,153,357,153z M204,153c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51\n                S232.05,153,204,153z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "drive", viewBox: "0 0 39.055 39.054" } }, [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M38.831,14.26c-0.191-0.233-0.476-0.369-0.775-0.369h-3.801c-0.938-2.474-2.16-4.898-3.549-5.813\n                c-4.805-3.161-17.55-3.161-22.355,0c-1.39,0.916-2.607,3.343-3.55,5.813H1c-0.302,0-0.586,0.136-0.775,0.369\n                c-0.19,0.232-0.266,0.539-0.204,0.834l0.563,2.728c0.096,0.465,0.506,0.797,0.979,0.797h1.126\n                c-1.087,1.254-1.614,2.833-1.621,4.413c-0.007,1.952,0.734,3.716,2.089,4.964c0.015,0.013,0.03,0.022,0.044,0.035v3.817\n                c0,0.827,0.672,1.5,1.5,1.5h3.506c0.828,0,1.5-0.673,1.5-1.5v-1.534h19.641v1.534c0,0.827,0.672,1.5,1.5,1.5h3.506\n                c0.826,0,1.5-0.673,1.5-1.5v-3.742c1.438-1.317,2.125-3.129,2.134-4.938c0.006-1.634-0.545-3.271-1.696-4.551h1.201\n                c0.475,0,0.885-0.332,0.979-0.798l0.564-2.727C39.094,14.799,39.021,14.494,38.831,14.26z M9.998,10.583\n                c3.83-2.521,15.229-2.521,19.057,0c0.744,0.488,1.701,2.461,2.578,4.877H7.422C8.297,13.045,9.254,11.073,9.998,10.583z\n                 M5.512,23.408c0-1.63,1.322-2.95,2.951-2.95c1.631,0,2.951,1.32,2.951,2.95s-1.32,2.951-2.951,2.951\n                C6.834,26.359,5.512,25.038,5.512,23.408z M30.631,26.359c-1.629,0-2.951-1.321-2.951-2.951s1.322-2.95,2.951-2.95\n                c1.631,0,2.951,1.32,2.951,2.95S32.26,26.359,30.631,26.359z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "fight", viewBox: "0 0 62.332 62.332" } }, [
          _c("g", [
            _c("circle", { attrs: { cx: "55.801", cy: "22.977", r: "6.531" } }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M49.847,28.748c-0.02-0.039-0.046-0.07-0.064-0.107l-8.92-17.716\n                c-0.818-1.628-2.805-2.282-4.432-1.464c-1.627,0.82-2.283,2.804-1.465,4.432l4.605,9.149c-4.838,0-9.675,0-14.514,0\n                c-0.758,0-1.445,0.111-2.063,0.312c-5.11-6.781-10.745-13.132-16.732-19.159C2.925,0.836-2.259,6.023,1.075,9.38\n                c6.302,6.345,12.278,13.024,17.516,20.281c0.14,0.193,0.291,0.362,0.447,0.518c0.04,0.336,0.103,0.668,0.191,0.993\n                c-0.023,0.177-0.04,0.357-0.04,0.55c0,7.983,0,15.972,0,23.955c0,4.729,7.333,4.729,7.333,0c0-6.722,0-13.443,0-20.164\n                c5.543,0,11.086,0,16.629,0c0.882,0,1.66-0.156,2.35-0.424l1.861,4.032l-1.75-0.534c-1.744-0.531-3.588,0.448-4.119,2.19\n                c-0.533,1.744,0.447,3.588,2.191,4.121l8.799,2.689c0.317,0.096,0.643,0.143,0.965,0.143c0.938,0,1.85-0.4,2.486-1.129\n                c0.854-0.98,1.056-2.373,0.51-3.553L49.847,28.748z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "sleep", viewBox: "0 0 490.7 490.7" } }, [
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M436.2,154.6H182.4c-12.4,0-33.1,4.7-33.1,36.6V240h320v-48.8C469.3,159.4,448.6,154.6,436.2,154.6z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("polygon", {
                attrs: {
                  points:
                    "80.3,250.6 32,250.6 32,80 0,80 0,410.7 32,410.7 32,325.3 458.7,325.3 458.7,410.6 490.7,410.6 490.7,250.6\n                ",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("circle", { attrs: { cx: "85.3", cy: "197.3", r: "44.7" } }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "eat", viewBox: "0 0 512 512" } }, [
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M498.682,435.326L297.917,234.56L63.357,0H45.026l-3.743,9.511c-9.879,25.104-14.1,50.78-12.205,74.249\n                c2.16,26.752,12.323,49.913,29.392,66.982L241.58,333.852l24.152-24.152l169.285,189.293c16.84,16.84,45.825,17.84,63.665,0\n                C516.236,481.439,516.236,452.879,498.682,435.326z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M156.728,291.442L13.317,434.853c-17.552,17.552-17.552,46.113,0,63.665c16.674,16.674,45.519,18.146,63.665,0\n                l143.412-143.412L156.728,291.442z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M490.253,85.249l-81.351,81.35l-21.223-21.222l81.351-81.351l-21.222-21.222l-81.35,81.35l-21.222-21.222l81.351-81.35\n                L405.366,0.361L299.256,106.471c-12.981,12.981-20.732,30.217-21.828,48.535c-0.277,4.641-1.329,9.206-3.074,13.548l68.929,68.929\n                c4.342-1.747,8.908-2.798,13.548-3.075c18.318-1.093,35.554-8.846,48.535-21.827l106.11-106.109L490.253,85.249z",
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "shower", viewBox: "-39 0 512 512" } }, [
          _c("path", {
            attrs: {
              d: "m333.335938 0h-115.335938c-55.140625 0-100 44.859375-100 100v58.789062c-66.648438 9.71875-118 67.242188-118 136.546876 0 11.042968 8.953125 20 20 20h236c11.046875 0 20-8.957032 20-20 0-69.304688-51.351562-126.828126-118-136.546876v-58.789062c0-33.085938 26.914062-60 60-60h115.332031c33.085938 0 60 26.914062 60 60v392c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-392c.003907-55.140625-44.859375-100-99.996093-100zm-99.386719 275.332031h-191.898438c9.257813-44.480469 48.761719-78 95.949219-78s86.691406 33.519531 95.949219 78zm-75.949219 88.835938v30c0 11.046875-8.953125 20-20 20s-20-8.953125-20-20v-30c0-11.046875 8.953125-20 20-20s20 8.953125 20 20zm-.238281 97.832031v30c0 11.046875-8.953125 20-20 20-11.042969 0-20-8.953125-20-20v-30c0-11.046875 8.957031-20 20-20 11.046875 0 20 8.953125 20 20zm-78.308594-97.832031v30c0 11.046875-8.957031 20-20 20-11.046875 0-20-8.953125-20-20v-30c0-11.046875 8.953125-20 20-20 11.042969 0 20 8.953125 20 20zm-.238281 97.832031v30c0 11.046875-8.953125 20-20 20s-20-8.953125-20-20v-30c0-11.046875 8.953125-20 20-20s20 8.953125 20 20zm157.097656-97.832031v30c0 11.046875-8.957031 20-20 20-11.046875 0-20-8.953125-20-20v-30c0-11.046875 8.953125-20 20-20 11.042969 0 20 8.953125 20 20zm-.238281 97.832031v30c0 11.046875-8.957031 20-20 20-11.046875 0-20-8.953125-20-20v-30c0-11.046875 8.953125-20 20-20 11.042969 0 20 8.953125 20 20zm0 0",
            },
          }),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "workout", viewBox: "0 0 512 512" } }, [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M466,30c-24.652,0-25.991,0-26.044,0c-0.002,0-0.003,0-0.002,0c-0.056,0-1.643,0-33.954,0c0-16.538-13.462-30-30-30\n                c-16.538,0-30,13.462-30,30h-47.763C292.024,12.578,275.53,0,256,0c-19.53,0-36.024,12.578-42.237,30H166\n                c0-16.538-13.462-30-30-30c-16.538,0-30,13.462-30,30c-27.003,0-32.527,0-60,0c-8.291,0-15,6.709-15,15v452\n                c0,8.291,6.709,15,15,15s15-6.709,15-15V60c15.892,0,29.333,0,45,0v60c0,12.935,8.247,24.36,20.508,28.462L181,166.622V482\n                c0,16.567,13.431,30,30,30c16.569,0,30-13.433,30-30c0-108.807,0-87.519,0-136c0-8.286,6.716-15,15-15s15,6.714,15,15\n                c0,75.536,0,89.951,0,136c0,16.567,13.431,30,30,30c16.569,0,30-13.433,30-30V166.622l54.492-18.16\n                C397.753,144.36,406,132.935,406,120V60c15.663,0,29.107,0,45,0v437c0,8.291,6.709,15,15,15c8.291,0,15-6.709,15-15V45\n                C481,36.709,474.291,30,466,30z M346,98.379L281.122,120h-50.244L166,98.379V60h47.763C219.976,77.422,236.47,90,256,90\n                c19.53,0,36.024-12.578,42.237-30H346V98.379z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("symbol", { attrs: { id: "knife", viewBox: "0 0 512 512" } }, [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M498.682,435.326L297.917,234.56L63.357,0H45.026l-3.743,9.511c-9.879,25.104-14.1,50.78-12.205,74.249\n            c2.16,26.752,12.323,49.913,29.392,66.982L241.58,333.852l24.152-24.152l169.285,189.293c16.84,16.84,45.825,17.84,63.665,0\n            C516.236,481.439,516.236,452.879,498.682,435.326z",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "symbol",
          { attrs: { id: "machete", viewBox: "-25 0 512 512.001" } },
          [
            _c("path", {
              attrs: {
                d: "m399.847656 213.289062c34.917969-21.824218 57.621094-57.808593 62.273438-98.714843 4.660156-40.914063-9.363282-81.0625-38.480469-110.175781-5.863281-5.863282-15.351563-5.863282-21.214844 0l-263.824219 262.933593 70.398438 70.398438zm0 0",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m140.527344 463.117188c-2.328125-5.644532-9.101563-9.25-15.183594-9.257813-7.746094-.042969-14.613281-4.652344-17.597656-11.757813-2.960938-7.144531-1.335938-15.296874 4.132812-20.765624l47.9375-47.9375 10.605469 10.605468c5.863281 5.863282 15.351563 5.863282 21.214844 0 5.863281-5.863281 5.863281-15.351562 0-21.210937-28.253907-28.253907-46.847657-46.851563-74.246094-74.246094-53.414063 53.410156-62.898437 62.894531-95.460937 95.457031-29.238282 29.242188-29.238282 76.824219 0 106.066406 29.242187 29.242188 76.828124 29.242188 106.066406 0l10.609375-10.605468c4.285156-4.289063 4.253906-10.742188 1.921875-16.347656zm0 0",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "symbol",
          { attrs: { id: "grenade", viewBox: "0 0 16.325 16.325" } },
          [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M8.555,8.24c-0.755,0-1.42-0.081-1.993-0.198c-0.12,0.924-0.063,1.865,0.091,2.761\n                c1.296,0.308,2.932,0.453,4.674,0.02c0.166-0.953,0.221-1.958,0.071-2.94C10.347,8.139,9.396,8.24,8.555,8.24z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M6.808,11.564c0.266,1.129,0.659,2.148,1.005,2.919c0.699,0.056,1.502,0.04,2.4-0.098\n                c0.333-0.753,0.702-1.725,0.957-2.797c-0.717,0.155-1.413,0.221-2.075,0.221C8.269,11.809,7.497,11.71,6.808,11.564z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M14.407,9.786c-0.059-2.044-1.035-3.834-2.484-4.873L6.098,4.915\n                C5.872,5.077,5.656,5.256,5.455,5.454c-0.334,0.273-0.633,0.59-0.883,0.952c0.012,0.008-0.393,0.742-0.413,0.729\n                C3.923,7.65,3.767,8.227,3.705,8.862C3.654,9.163,3.623,9.469,3.614,9.784L3.61,10.106c0.371,3.545,2.692,6.219,5.401,6.219\n                c2.7,0,5.021-2.667,5.397-6.203L14.407,9.786z M12.829,13.673c0.222-0.338,0.418-0.699,0.586-1.074\n                C13.246,12.982,13.048,13.342,12.829,13.673z M14.048,10.042l-0.019,0.407c-0.019,0.127-0.041,0.252-0.064,0.376\n                c0.021-0.118,0.04-0.236,0.055-0.355c-0.646,0.379-1.293,0.663-1.93,0.869c-0.032,0.154-0.063,0.308-0.101,0.464\n                c-0.211,0.884-0.494,1.696-0.774,2.384c0.509-0.123,1.042-0.284,1.601-0.494c-0.463,0.692-1.028,1.256-1.658,1.652\n                c0.229-0.155,0.45-0.33,0.66-0.524c-0.316,0.087-0.622,0.159-0.921,0.22c-0.103,0.223-0.2,0.423-0.289,0.599\n                c-0.44,0.196-0.904,0.316-1.384,0.344c0.077-0.008,0.154-0.017,0.23-0.028l-0.026-0.017c0.009-0.015,0.19-0.315,0.441-0.82\n                C9.405,15.174,8.966,15.2,8.553,15.2c-0.138,0-0.272-0.003-0.404-0.009c0.232,0.461,0.397,0.734,0.406,0.748l-0.032,0.02\n                c-0.372-0.048-0.733-0.15-1.08-0.303c-0.083-0.161-0.174-0.345-0.272-0.551c-0.309-0.042-0.594-0.098-0.859-0.16\n                c-0.343-0.288-0.661-0.629-0.945-1.017c0.371,0.149,0.862,0.311,1.47,0.427c-0.303-0.722-0.615-1.595-0.844-2.551\n                c-0.038-0.159-0.069-0.315-0.102-0.472c-0.824-0.243-1.473-0.528-1.875-0.728c-0.01-0.062-0.021-0.123-0.03-0.187l-0.024-0.395\n                c-0.015-0.021-0.016-0.033-0.016-0.043c0-0.064,0.002-0.129,0.004-0.193c0.245,0.136,0.888,0.469,1.804,0.765\n                C5.62,9.585,5.619,8.678,5.741,7.833C5.214,7.671,4.805,7.488,4.525,7.344c0.12-0.258,0.257-0.504,0.411-0.736\n                c0.227,0.113,0.552,0.254,0.975,0.387c0.194-0.744,0.5-1.429,0.912-2.05h1.034c-0.566,0.697-0.928,1.464-1.134,2.26\n                C7.838,7.433,9.359,7.51,11.22,7.059c-0.21-0.744-0.561-1.46-1.091-2.114h1.03c0.383,0.577,0.673,1.208,0.868,1.89\n                c0.317-0.099,0.644-0.212,0.978-0.342c0.16,0.23,0.305,0.474,0.432,0.73c-0.419,0.168-0.826,0.313-1.221,0.435\n                c0.149,0.892,0.155,1.859,0.013,2.89c0.564-0.204,1.136-0.473,1.705-0.824c0,0,0.087-0.058,0.126-0.153\n                c0.009,0.136,0.015,0.271,0.015,0.41C14.075,9.986,14.075,10.008,14.048,10.042z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M3.38,2.507C2.497,3.565,1.824,5.425,1.928,8.671L2.43,8.309c0,0,0.225-3.088,1.516-4.959\n                C3.689,3.12,3.493,2.832,3.38,2.507z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M5.626,3.685c0.231,0,0.451-0.041,0.657-0.111L6.152,4.671h5.678c0,0,0.067-1.576-0.109-2.613\n                h0.278c0.219,0,0.396-0.15,0.396-0.335V1.382c0-0.185-0.177-0.334-0.396-0.334H7.374C7.061,0.429,6.396,0,5.626,0\n                c-1.07,0-1.94,0.827-1.94,1.842C3.686,2.858,4.557,3.685,5.626,3.685z M5.626,3.35c-0.496,0-0.94-0.212-1.235-0.545\n                c0.451-0.463,1-0.782,1.674-0.842c0.072,0.059,0.169,0.095,0.276,0.095h0.124l-0.096,0.8L6.328,3.196\n                C6.116,3.293,5.878,3.35,5.626,3.35z M5.626,0.334c0.575,0,1.079,0.286,1.362,0.713H6.506H6.341c-0.119,0-0.224,0.045-0.297,0.115\n                C5.48,1.195,4.73,1.364,4.023,1.896c0-0.018-0.003-0.036-0.003-0.055C4.02,1.011,4.741,0.334,5.626,0.334z",
                },
              }),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "symbol",
          { attrs: { id: "firearm", viewBox: "0 0 22.737 22.737" } },
          [
            _c("path", {
              attrs: {
                d: "M22.294,5.665v-1.65h-0.096V3.431h-0.675v0.584c0,0-13.795,0.116-16.644,0\n            c-0.985,0-3.956,2.036-2.007,5.032c0,0,0.146-1.077,0.698,0c0,0,0.436,0.772-1.119,2.69c-1.532,1.892-2.223,5.722-2.403,6.879H0\n            v0.689h5.81v-0.689H5.59c1.206-1.056,1.976-3.648,2.42-5.983c0.166,0.042,0.339,0.069,0.518,0.069h1.841\n            c1.139,0,2.646-1.218,2.646-2.356c0-0.492-0.174-0.944-0.462-1.299h9.741v-1.65h0.443V5.665H22.294z M11.713,10.346\n            c0,0.741-0.604,1.345-1.344,1.345H8.528c-0.136,0-0.267-0.021-0.39-0.06c0.108-0.63,0.191-1.196,0.25-1.638\n            c0.155,0.511,0.457,1.047,1.05,1.278c0.042,0.016,0.084,0.023,0.126,0.023c0.14,0,0.271-0.084,0.326-0.223\n            c0.07-0.18-0.019-0.381-0.199-0.452c-0.615-0.238-0.737-1.167-0.76-1.573h1.773C11.283,9.198,11.713,9.723,11.713,10.346z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "symbol",
          { attrs: { id: "prompt", viewBox: "0 0 22.737 22.737" } },
          [
            _c("path", {
              attrs: {
                d: "M12 3C7.03 3 3 6.58172 3 11C3 12.8494 3.74167 14.5556 5 15.8478V21L9.66045 18.3961C10.6961 18.7767 11.8267 19 13 19C17.97 19 22 15.4183 22 11C22 6.58172 17.97 3 12 3ZM5.5 15.1042C4.29833 13.8704 3.5 12.2434 3.5 11C3.5 7.41015 7.24672 4.5 12 4.5C16.7533 4.5 20.5 7.41015 20.5 11C20.5 14.5898 16.7533 17.5 12 17.5C10.8867 17.5 9.82332 17.3024 8.85035 16.9332L5.5 18.787V15.1042ZM12 5.5C8.41015 5.5 5.5 8.16498 5.5 11C5.5 12.7096 6.34947 14.2302 7.75 15.1042L8.15035 14.3668C6.91166 13.5823 6 12.3534 6 11C6 8.51471 8.51472 6 12 6C15.4853 6 18 8.51471 18 11C18 12.3534 17.0883 13.5823 15.8496 14.3668L16.25 15.1042C17.6505 14.2302 18.5 12.7096 18.5 11C18.5 8.16498 15.5899 5.5 12 5.5Z",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.openedMenu, function (menu, index) {
        return _c(
          "svg",
          {
            staticClass: "menu",
            class: { inner: menu.inner, outer: menu.outer },
            attrs: {
              width: _vm.size,
              height: _vm.size,
              viewBox: "-50 -50 100 100",
              id: "lvl" + menu.level,
            },
          },
          [
            _vm._l(menu.sectors, function (sector, index) {
              return _c(
                "g",
                {
                  class: {
                    sector: sector.id,
                    dummy: !sector.id,
                    selected: menu.selectedIndex == sector.itemIndex,
                  },
                  attrs: {
                    "data-id": sector.id,
                    "data-index": index,
                    transform: sector.transform,
                    "data-item-index": sector.itemIndex,
                  },
                  on: {
                    click: _vm.$_sectorClick,
                    mouseover: _vm.$_sectorHover,
                  },
                },
                [
                  _c("path", { attrs: { d: sector.d } }),
                  _vm._v(" "),
                  sector.title
                    ? _c(
                        "text",
                        {
                          attrs: {
                            "text-anchor": "middle",
                            "font-size": "20%",
                            x: sector.centerX,
                            y: sector.centerY,
                            transform: sector.textTransform,
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(sector.title) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  sector.icon
                    ? _c("use", {
                        attrs: {
                          "xlink:href": sector.icon,
                          x: sector.centerX,
                          y: sector.centerY,
                          transform: sector.useTransform,
                          width: "10",
                          height: "10",
                          fill: "white",
                        },
                      })
                    : _vm._e(),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "center", on: { click: _vm.$_centerClick } },
              [
                _c("circle", { attrs: { r: menu.centerRadius } }),
                _vm._v(" "),
                _c("use", {
                  attrs: {
                    "xlink:href": menu.centerIcon,
                    transform: menu.centerTransform,
                    width: menu.centerSize,
                    height: menu.centerSize,
                  },
                }),
              ]
            ),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }